import * as t from "io-ts";
import { RewardScarcity, RewardTypes } from "../../enums";
import { timestampCodec } from "../../validation/codecs";
import { enumCodec, mixed, optional, required } from "../../validation/validator";
import { CallResponseSchema } from "../common/callResponseSchema";

/****************************************************
 * Rewards
 */
export const commonRewardFields = {
  // required
  name: t.string,
  description: t.string,
  value: t.number,
  earned_at: t.string,
  type: enumCodec(RewardTypes),
  scarcity: enumCodec(RewardScarcity),
  goal: t.string,

  // optional
  image_url: t.union([t.string, t.undefined, t.null]),
};

export const RewardRecordSchema = t.type({
  id: t.number,
  created_at: timestampCodec,
  updated_at: t.union([timestampCodec, t.undefined, t.null]),
  ...commonRewardFields,
});
export type RewardRecord = t.TypeOf<typeof RewardRecordSchema>;

export const RewardRecordInsertSchema = t.type({
  updated_at: t.union([timestampCodec, t.undefined, t.null]),
  ...commonRewardFields,
});

export const CreateRewardSchema = t.type(commonRewardFields);

export const CreateRewardsSchema = t.type({
  rewards: t.array(CreateRewardSchema),
});

export type CreateRewardRequest = t.TypeOf<typeof CreateRewardSchema>;
export type CreateRewardsRequest = t.TypeOf<typeof CreateRewardsSchema>;
export type RewardInsertRecord = t.TypeOf<typeof RewardRecordInsertSchema>;

export const UpdateRewardSchema = t.intersection([t.type({ id: t.number }), t.partial(commonRewardFields)]);
export type UpdateRewardRequest = t.TypeOf<typeof UpdateRewardSchema>;

/****************************************************
 * GetRewards
 */
export const GetRewardsSchema = optional({
  user_id: t.union([t.string, t.undefined, t.null]),
  // challenge_id: t.union([t.number, t.undefined]),
  limit: t.union([t.number, t.undefined]),
  offset: t.number,
  latest_per_challenge: t.boolean,
  types: t.array(enumCodec(RewardTypes)),
  ids: t.union([t.array(t.number), t.undefined]),
  distinct: t.union([t.boolean, t.undefined]),
});

export type GetRewardsRequest = t.TypeOf<typeof GetRewardsSchema>;

export const GetRewardStatsSchema = t.type({
  challenge_id: t.union([t.number, t.undefined]),
  reward_ids: t.union([t.array(t.number), t.undefined]),
  indistinct: t.union([t.boolean, t.undefined]),
});

export type GetRewardStatsRequest = t.TypeOf<typeof GetRewardStatsSchema>;

// Client API
export const RewardApis = {
  Rewards: {
    CreateRewards: {
      Name: "rewards-createRewards",
      Request: CreateRewardsSchema,
      Response: RewardRecordSchema,
    },
    GetRewards: {
      Name: "rewards-temp-getRewards",
      Request: GetRewardsSchema,
      Response: mixed([required({ data: t.array(RewardRecordSchema) }), optional({ total: t.number, hasMore: t.boolean }), CallResponseSchema]),
    },
    UpdateReward: {
      Name: "rewards-updateReward",
      Request: UpdateRewardSchema,
      Response: RewardRecordSchema,
    },
    GetRewardStats: {
      Name: "rewards-temp-getRewardStats",
      Request: GetRewardStatsSchema,
      Response: t.array(RewardRecordSchema),
    },
  },
};
